import { render, staticRenderFns } from "./CategoryCard.vue?vue&type=template&id=a566b21e&"
import script from "./CategoryCard.vue?vue&type=script&lang=js&"
export * from "./CategoryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports